import { gql } from '@apollo/client';

export interface UpdateWorkflowTemplateInput {
    id: number;
    name: string;
    status: number;
    definitionJson: string;
    description?: string | null;
}

export interface UpdateWorkflowTemplateResponse {
    updateWorkflowTemplate: boolean;
}

export interface UpdateWorkflowTemplateVariables {
    input: UpdateWorkflowTemplateInput;
}

export const UPDATE_WORKFLOW_TEMPLATE = gql`
    mutation UpdateWorkflowTemplate($input: UpdateWorkflowTemplateInput!) {
        updateWorkflowTemplate(input: $input)
    }
`;
